import { Campaign } from "./service";

export const getCampaignName = (campaigns: Campaign[], campaignId: string): string => {
  const campaign = campaigns.find(c => c.parent_campaign_id === campaignId);
  return campaign ? campaign.campaign_name : 'Unknown Campaign';
};